import React, { useEffect, useState } from "react";
import PayslipGenerationPage from "../../../../entities/DashboardPage/HRModule/PayslipGenerationPage";
import { useLocation } from "react-router-dom";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";

const PayslipGeneration = () => {
  const {state} = useLocation();
  const {id} = state || {};
  const [pdf,setPdf] =useState();
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || (role !== "Employee" && role !== "employee")) {
      if(id){
        getSlip(id);
      }
    }
  }, [id, permission])
  const getSlip =  async() =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSalarySlip(id);
      // const blob = new Blob([result], { type: "application/pdf" });
      // const pdfUrl = URL.createObjectURL(blob);
      setPdf(result);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  // Don't render until permissions are loaded for Employee role
  if (permission === null && (role === "Employee" || role === "employee")) {
    return null;
  }

  // Check if user has permission to view payslip
  const hasViewPermission = permission?.payslip?.isView === true || role === "Admin" || role === "SuperAdmin";
  const hasEditPermission = permission?.payslip?.isEdit === true || role === "Admin" || role === "SuperAdmin";

  if (!hasViewPermission && !hasEditPermission) {
    return null; // Or show access denied message
  }

  return (
    <>
      <PayslipGenerationPage id={id} pdf={pdf} setPdf={setPdf} permission={permission} role={role}/>
    </>
  )

}

export default PayslipGeneration;
